import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <path d="M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z" />,
  'CallReceived',
);
